import type { Router } from 'vue-router'

export const businessRoutesState: {
  hasAdded: boolean
  accessToken: string | null
} = {
  hasAdded: false,
  accessToken: null
}

export const resetBusinessRoutes = (router: Router) => {
  if (router.hasRoute('index')) {
    router.removeRoute('index')
  }
  businessRoutesState.hasAdded = false
  businessRoutesState.accessToken = null
}

export const ensureBusinessRoutesAccount = (router: Router, accessToken: string) => {
  if (businessRoutesState.accessToken !== accessToken) {
    resetBusinessRoutes(router)
  }
}
